import {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  interpolateColor,
} from 'react-native-reanimated'
import { useEffect } from 'react'
import { getStatusValue } from './types'
import { colorStatus as c } from './styles'
import Typography from '@ui/typography'
import cn from '@ui/utils/cn'
import { leadingNone } from '@ui/typography/styles'
import { OptionBadgeProps as Props } from './types'
import { AnimatedPressable } from '@ui/animated/nativewindReanimated'

export default function OptionBadge({ text, status, ...props }: Props) {
  const animation = useSharedValue(getStatusValue(status))

  const styleContainer = useAnimatedStyle(() => ({
    backgroundColor: interpolateColor(
      animation.value,
      [-1, 0, 1],
      [c.disabled.back, c.default.back, c.active.back]
    ),
  }))

  const styleText = useAnimatedStyle(() => ({
    color: interpolateColor(
      animation.value,
      [-1, 0, 1],
      [c.disabled.front, c.default.front, c.active.front]
    ),
  }))

  useEffect(() => {
    animation.set(withTiming(getStatusValue(status), { duration: 500 }))
  }, [status, animation])

  return (
    <AnimatedPressable
      style={styleContainer}
      disabled={status === 'disabled'}
      className="flex h-8 items-center justify-center rounded-sm px-4"
      {...props}
    >
      <Typography
        variant="SMB"
        style={styleText}
        className={cn(
          leadingNone,
          'font-text-semibold select-none font-semibold'
        )}
      >
        {text}
      </Typography>
    </AnimatedPressable>
  )
}
